const ITEMS = [
    "Gestion complète",
    "Montréal",
    "Commission au résultat",
    "Mont-Tremblant",
    "Ménage hôtelier 5*",
    "Ville de Québec",
    "Photos professionnelles",
    "Charlevoix",
    "Conciergerie 24/7",
    "Gatineau",
    "Annonce optimisée",
    "Sherbrooke",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#8A7563]/20 bg-[#FFFFFF] py-4">
            <div className="marquee-track">
                {row.map((item, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-8 pr-8 font-mono-accent text-xs uppercase tracking-[0.3em] text-[#8A7563]/80"
                    >
                        {item}
                        <span className="text-[#8A7563]/40">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
